import { action } from 'satcheljs';

export const messageSendValidationFailed = action(
    'messageSendValidationFailed',
    (composeId: string, errorCode: string, forceSend: boolean) => ({
        composeId,
        errorCode,
        forceSend,
    })
);
